import { Box } from '@mui/material';
import { useResizeObserver } from '@procureai/uix';
import { useRef } from 'react';

export interface ResponsiveContainerProps {
  className?: string;
  children: (size: { width: number; height: number }) => React.ReactElement;
}

export const ResponsiveContainer = ({ className, children }: ResponsiveContainerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { width = 0, height = 0 } = useResizeObserver({ ref });
  return (
    <Box ref={ref} className={className} sx={{ flex: '1 1 0', position: 'relative' }}>
      {width > 0 && height > 0 ? (
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
          }}
        >
          {children({ width, height })}
        </Box>
      ) : null}
    </Box>
  );
};
